import { pageJump } from '@/hooks/useJump';
const pageJump_ = pageJump();
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
export default [
  {
    path: '/IFPageSeventeenPreLogin',
    name: 'pageSeventeenPreLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventeen/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (from.path === '/IFPageSeventeenLogin') {
        pageJump_.jump();
      }
      next();
    },
  },
  {
    path: '/IFPageSeventeenLogin',
    name: 'pageSeventeenLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventeen/login.vue'),
  },
  {
    path: '/IFPageSeventeenLeaveInfo',
    name: 'pageSeventeenLeaveInfo',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventeen/leaveInfo.vue'),
  },
  {
    path: '/IFPageSeventeenResult',
    name: 'pageSeventeenResult',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventeen/result.vue'),
  },
  {
    path: '/IFPageSeventeenLoading',
    name: 'pageSeventeenLoading',
    component: () => import('@/pages/pageListAll/pageSeventeen/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageSeventeenCar',
    name: 'pageSeventeenCar',
    component: () => import('@/pages/pageListAll/pageSeventeen/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
];
